<template>
  <div>
    <v-form @submit.prevent="resetPassword" ref="ResetPasswordForm">
      <PasswordInput
        v-model="resetPasswordData.password"
        :validationRules="passwordValidation(resetPasswordData.password)"
        label="新しいパスワード"
      />
      <PasswordInput
        v-model="resetPasswordData.passwordConfirmation"
        :validationRules="confirmationPasswordValidation(resetPasswordData.passwordConfirmation,resetPasswordData.password)"
        label="新しいパスワード（確認）"
      />
      <ResetPasswordButton
        label="パスワードを変更する"
        @resetPassword="resetPassword"
        class="mt-2"
      />
    </v-form>
  </div>
</template>
<script>
import PasswordInput from '/src/components/uiParts/inputFields/PasswordInput'
import ResetPasswordButton from '/src/components/pages/ResetPassword/ResetPasswordButton'
import api from '@/plugins/api'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  name: 'SignInContainer',
  components: {
    PasswordInput,
    ResetPasswordButton
  },
  mixins: [formValidationUtils],
  data () {
    return {
      resetPasswordData: {
        password: '',
        passwordConfirmation: '',
        resetPasswordToken: null
      }
    }
  },
  methods: {
    async resetPassword () {
      if (!this.$refs.ResetPasswordForm.validate()) return false

      this.$store.dispatch('LoaderStore/displayLoader')
      this.resetPasswordData.resetPasswordToken = this.$route.query.reset_password_token
      const query = { userAuth: this.resetPasswordData }
      try {
        await api.resetPassword(query)
        const payload = {
          status: 200,
          message: 'パスワードを変更しました。'
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
        this.$router.push('/user_auths/sign_in')
      } catch (error) {
        this.$store.dispatch('LoaderStore/hideLoader')
        const payload = {
          status: error.response.status,
          message: error.response.data.message
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      } finally {
        this.$store.dispatch('LoaderStore/hideLoader')
      }
    }
  }
}
</script>
